import {CSSProperties} from "react";

export default function CloseIcon({
                                  color = "#000",
                                  size = 24,
    style
                              }: {
    color?: string,
    size?: number,
    style?: CSSProperties

}) {
    return <svg style={style} width={size} height={size} viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1L14.5 14.5M28 28L14.5 14.5M14.5 14.5L1 28L28 1" stroke={color} strokeWidth="2"/>
    </svg>
}